import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";

import { ChangePasswordComponent } from "@bitwarden/angular/auth/password-management/change-password";
import { IconButtonModule, IconModule } from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";

import { WebInputPasswordComponent } from "./web-input-password.component";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "app-web-change-password",
  templateUrl: "./web-change-password.component.html",
  imports: [CommonModule, IconButtonModule, IconModule, WebInputPasswordComponent, I18nPipe],
})
export class WebChangePasswordComponent extends ChangePasswordComponent {
  showWarning = true;
}
